import { Alert, Stack, Typography } from "@mui/material";
import {
  ImpuritiesPlot,
  ImpuritiesPlotSkeleton,
} from "components/common/plots/ImpuritiesPlotByTenant";
import { toImpuritiesConstraint } from "components/common/plots/ImpuritiesPlotCommon";
import { useTenantTranslation, useUnitsFormatter } from "hooks/formatters";
import { useShortLanguage, useTenant } from "hooks/settings";
import { Fetching } from "src/components/common/loading/fetching";
import {
  SupportedLanguage,
  useGetRecipesImpuritiesStatsQuery,
} from "src/store/api/generatedApi";

const PLOT_HEIGHT = 330;
export const ImpuritiesTab = ({
  planId,
  mixId,
  period,
}: {
  planId: number;
  mixId: number;
  period: number;
}) => {
  const language = useShortLanguage();
  const { t } = useTenantTranslation();
  const units = useUnitsFormatter(true);

  const parameters = {
    tenantName: useTenant(),
    planId: planId,
    mixId: mixId,
    period: period,
    language: language as SupportedLanguage,
  };

  const impuritiesQuery = useGetRecipesImpuritiesStatsQuery(parameters);
  const constraints = impuritiesQuery.data?.map(toImpuritiesConstraint);
  return (
    <Stack alignItems="center">
      {impuritiesQuery.isLoading ? (
        <Stack alignItems="stretch" sx={{ width: "100%" }}>
          <ImpuritiesPlotSkeleton height={PLOT_HEIGHT} />
        </Stack>
      ) : impuritiesQuery.isError || constraints === undefined ? (
        <Alert severity="error">{t("errorLoadingPlot")}</Alert>
      ) : (
        <Fetching fetching={impuritiesQuery.isFetching}>
          <Typography variant="h5" marginTop={2}>
            {t("massFraction")} {units("mass_fraction")}
          </Typography>
          <ImpuritiesPlot constraints={constraints} height={PLOT_HEIGHT} />
        </Fetching>
      )}
    </Stack>
  );
};
